module.exports = __webpack_public_path__ + "img/certificazioni.e47ccd59.png";